module.exports = __webpack_public_path__ + "img/12.55489f36.jpg";